import { Component, OnInit } from '@angular/core';
import { FlagsService } from 'src/app/services/config/flags.service';

@Component({
  selector: 'app-mm-under-maintenance',
  templateUrl: './mm-under-maintenance.component.html',
  styleUrls: ['./mm-under-maintenance.component.scss'],
})
export class MmUnderMaintenanceComponent  implements OnInit {

  constructor(public flagsService: FlagsService) { }

  ngOnInit() {}

}
